export default "{\n    \"dismissButton\": \"J'ai compris!\"\n}\n"